<template>
  <div class="vehicleOwner">
    <!-- <el-drawer size="100%"
               :data="visible"
               :visible.sync="visible"
               title="运单列表"
               :before-close="cancelModal"> -->
   
    <companyWaybill :info="info" :isBack="true"></companyWaybill>
    <!-- </el-drawer> -->
  </div>
</template>

<script>
import companyWaybill from "@/views/chain/waybillPreset";
export default {
  props: {
    //弹窗状态
    visible: {
      type: Boolean,
      default: false,
    },
    // info: {
    //   type: Object,
    //   default: ()=>{
    //     return {}
    //   },
    // },
  },
  components: {
    companyWaybill,
  },
  data() {
    return {
      info: {},
    };
  },
  created() {
    this.info = this.$route.query;

  },
  mounted() {
    // debugger
    console.info(this.info,"-------hhhhhh-------")
  },
  methods: {
    back(){
      this.$router.go(-1)
    },
    cancelModal() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-drawer__body {
  padding: 0;
}
.add-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // margin-bottom: 24px;
  .left-title {
    font-weight: 500;
    font-size: 16px;
    color: #313133;
  }
}
</style>
